import { Row, Col } from 'react-bootstrap';
import SimpleCard from 'components/global/SimpleCard';
import { formatMoneyNoDecimals } from 'utils/formatMoney';
import { $detail } from 'signals/global.signals';

const PublicRoomHighlights = () => (
  <SimpleCard className="bg-dark text-light p-16">
    <h6 className="fw-600 m-0 text-muted pb-16">Room Name: {$detail.value.name}</h6>
    <Row className="mb-32">
      <Col>
        <h4 className="fw-600 text-gradient-info-white">{formatMoneyNoDecimals($detail.value.currentRaiseSize)}</h4>
        <div><small>{$detail.value.investmentStage} - {$detail.value.typeOfRaise}</small></div>
      </Col>
      <Col>
        <h4 className="fw-600 text-gradient-primary-white">{formatMoneyNoDecimals($detail.value.currentValue ?? 0)}</h4>
        <div><small>Valuation</small></div>
      </Col>
    </Row>
    <Row>
      <Col>
        <h4 className="fw-600 text-gradient-success-white">{formatMoneyNoDecimals($detail.value.amountCommitted)}</h4>
        <div><small>Raised to Date</small></div>
      </Col>
      <Col>
        <h4 className="fw-600 text-gradient-warning-white">{formatMoneyNoDecimals($detail.value?.minimumInvestment)}</h4>
        <div><small>Min Investment</small></div>
      </Col>
    </Row>
  </SimpleCard>
);

export default PublicRoomHighlights;
